import { message } from "antd";
import { errToolTip } from "../common/util";

let ws = null;
let socketOpen = false;

export const initWebSocket = () => {
	return new Promise((resolve) => {
		let userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
		ws = new WebSocket("ws://127.0.0.1:8181?key=" + (userInfo.USER_UID || "0"));
		ws.onopen = () => {
			socketOpen = true;
			resolve();
		};
		ws.onerror = () => {
			message.error("请启动 PYAnalysis 服务控件");
			window.location.href = "PYMonitor://1";
		};
		ws.onclose = () => {
			errToolTip();
		};
	});
};

//发送消息
export const sendMessage = (params) => {
	console.log(params, socketOpen);
	params = {
		...params,
		SERVER: window.g.baseURL
	};
	if (socketOpen) {
		ws.send(JSON.stringify(params));
	}
};

//接收消息
export const receiveMessage = (callBack) => {
	if (ws) {
		ws.onmessage = (evt) => {
			let data = JSON.parse(evt.data);
			callBack(data);
		};
	}
};
